import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import SportBets from 'views/cash/bets/sport'; // Importing SportBets component
import { devConfig, profile, relationshipUserOnline } from 'config/config'; // Importing configuration settings

/**
 * Class representing the reprintCheckView.
 * @extends JetView
 */
export default class reprintCheckView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Popup for unregistered user notification
        const popup21 = webix.ui({
            id: 'filterPopup21',
            view: 'window',
            position: 'center',
            modal: true,
            css: {
                'border-width': '0px !important',
                'border-radius': '10px !important',
            },
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label:
                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                            _('USUARIO NO REGISTRADO') +
                            `</span>`,
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
                css: {
                    'background-color': '#404563',
                    color: 'white !important',
                },
            },
            body: {
                width: 570,
                height: 200,
                padding: 10,
                rows: [
                    {
                        view: 'label',
                        label: "<span style='font-size: 20px; font-weight: normal'>No tienes una cuenta asociada.</span>",
                        css: {
                            'text-align': 'center',
                        },
                    },
                    {
                        view: 'label',
                        label: '<span>Para acceder a nuestras apuestas, <strong>por favor regístrate.</strong></span>',
                        css: {
                            'text-align': 'center',
                        },
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: 'Salir',
                                autowidth: true,
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: 'Regístrate aquí',
                                css: 'webix_primary',
                                hidden: profile.linkAffiliate === null || profile.linkAffiliate === '', // Hide if no affiliate link
                                autowidth: true,
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    window.open(
                                        profile.linkAffiliate,
                                        '_blank', // Open affiliate link in a new tab
                                    );
                                },
                            },
                        ],
                        css: {
                            display: 'flex',
                            'justify-content': 'center',
                            'align-items': 'center',
                            gap: '10px',
                            'margin-top': '15px !important',
                        },
                    },
                ],
                css: {
                    display: 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'align-items': 'center',
                    gap: '0px !important',
                },
            },
        });

        // Popup for user identification
        const popup11 = webix.ui({
            view: 'window',
            id: 'filterPopup11',
            css: {
                'border-width': '0px !important',
                'border-radius': '10px !important',
            },
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label:
                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                            _('IDENTIFICACIÓN') +
                            `</span>`,
                        textAlign: 'center',
                        css: {
                            color: '#fff !important',
                            'font-size': '20px',
                            'font-weight': 'bold',
                            'text-transform': 'uppercase',
                        },
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                            $$('myForm222').clear(); // Clear the form
                        },
                    },
                ],
                css: {
                    'background-color': '#404563',
                    color: 'white !important',
                },
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm222',
                type: 'clean',
                width: 570,
                height: 170,
                paddingX: 20,
                paddingY: 10,
                rows: [
                    {
                        view: 'text',
                        name: 'docnumber',
                        id: 'docnumber',
                        type: 'number',
                        // Define the label text dynamically based on which anonymous betting options are active
                        label:
                        // If both document and phone options are active
                            (profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                ? '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de documento o celular.</strong></span>'
                                // If only phone is active
                                : (!profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                    ?  '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de celular.</strong></span>'
                                    // Otherwise, only document is active
                                    : '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de documento.</strong></span>',
                        labelPosition: 'top',
                        required: true,
                        invalidMessage: _(
                            'Por favor, introduce tu documento de identificación', // Validation message
                        ),
                        css: 'webix_inputNumber',
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Continuar'),
                                type: 'form',
                                width: 150,
                                css: 'webix_primary',
                                click: function () {
                                    const form = $$('myForm222'); // Get the form instance
                                    if (form.validate()) {
                                        // Validate the form
                                        const values = form.getValues(); // Get form values
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Account/ExitsDocument', // API endpoint
                                                values,
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        localStorage.removeItem(
                                                            'relationshipUserOnline', // Clear local storage on error
                                                        );
                                                        devConfig.setRelationshipUserOnline('');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            // Check for errors
                                                            localStorage.removeItem(
                                                                'relationshipUserOnline', // Clear local storage on error
                                                            );
                                                            devConfig.setRelationshipUserOnline('');
                                                            popup21.show(); // Show unregistered user popup
                                                        } else {
                                                            webix
                                                                .ui({
                                                                    id: 'filterPopup31',
                                                                    view: 'window',
                                                                    position: 'center',
                                                                    modal: true,
                                                                    css: {
                                                                        'border-width': '0px !important',
                                                                        'border-radius': '10px !important',
                                                                    },
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                                                                                    _('USUARIO REGISTRADO') +
                                                                                    `</span>`,
                                                                            },
                                                                            {
                                                                                view: 'icon',
                                                                                icon: 'wxi-close',
                                                                                click: function () {
                                                                                    this.getTopParentView().hide(); // Close the popup
                                                                                },
                                                                            },
                                                                        ],
                                                                        css: {
                                                                            'background-color': '#404563',
                                                                            color: 'white !important',
                                                                        },
                                                                    },
                                                                    body: {
                                                                        width: 500,
                                                                        height: 250,
                                                                        padding: 10,
                                                                        rows: [
                                                                            {
                                                                                view: 'label',
                                                                                label: "<span style='font-size: 18px; font-weight: normal'>¿Son estos tus datos?</span>",
                                                                                css: {
                                                                                    'text-align': 'center',
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                    _('ID:') +
                                                                                    ' ' +
                                                                                    json.data.id +
                                                                                    `</span>`,
                                                                                css: {
                                                                                    'text-align': 'center',
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                // Dynamically sets the label based on which anonymous betting options are enabled
                                                                                label:
                                                                                // If both Document and Phone options are enabled
                                                                                    (profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                                                                        ? `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                        _('DOCUMENTO O CELULAR:') + json.data.value +
                                                                                        `</span>`
                                                                                        // If only Phone is enabled
                                                                                        : (!profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                                                                            ? `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                            _('CELULAR:') + json.data.value +
                                                                                            `</span>`
                                                                                            // Otherwise, only Document is enabled
                                                                                            : `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                            _('DOCUMENTO:') + json.data.value +
                                                                                            `</span>`,
                                                                                css: {
                                                                                    'text-align': 'center',
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='font-size: 20px; font-weight: bold; text-transform: uppercase'>` +
                                                                                    json.data.name +
                                                                                    `</span>`,
                                                                                css: {
                                                                                    'text-align': 'center',
                                                                                },
                                                                            },
                                                                            {
                                                                                cols: [
                                                                                    {
                                                                                        view: 'button',
                                                                                        value: 'Cancelar',
                                                                                        autowidth: true,
                                                                                        click: function () {
                                                                                            this.getTopParentView().hide(); // Close the popup
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        type: 'form',
                                                                                        value: 'Si, comenzar a apostar',
                                                                                        css: 'webix_primary',
                                                                                        autowidth: true,
                                                                                        click: function () {
                                                                                            let vthis = this;
                                                                                            webix
                                                                                                .ajax()
                                                                                                .headers({
                                                                                                    'Content-type':
                                                                                                        'application/json',
                                                                                                })
                                                                                                .post(
                                                                                                    devConfig.geturlApi() +
                                                                                                        'Account/OnlineUserRelationship',
                                                                                                    {
                                                                                                        docnumber:
                                                                                                            json.data
                                                                                                                .id,
                                                                                                    },
                                                                                                    {
                                                                                                        error: function (
                                                                                                            text,
                                                                                                            data,
                                                                                                            XmlHttpRequest,
                                                                                                        ) {
                                                                                                            localStorage.removeItem(
                                                                                                                'relationshipUserOnline', // Clear local storage on error
                                                                                                            );
                                                                                                            devConfig.setRelationshipUserOnline(
                                                                                                                '',
                                                                                                            );
                                                                                                            window.location.reload(); // Reload the page
                                                                                                        },
                                                                                                        success:
                                                                                                            function (
                                                                                                                text,
                                                                                                                data,
                                                                                                                XmlHttpRequest,
                                                                                                            ) {
                                                                                                                localStorage.setItem(
                                                                                                                    'relationshipUserOnline',
                                                                                                                    JSON.stringify(
                                                                                                                        json.data,
                                                                                                                    ), // Store user relationship in local storage
                                                                                                                );
                                                                                                                window.location.reload(); // Reload the page
                                                                                                            },
                                                                                                    },
                                                                                                );
                                                                                        },
                                                                                    },
                                                                                ],
                                                                                css: {
                                                                                    display: 'flex',
                                                                                    'justify-content': 'center',
                                                                                    'align-items': 'center',
                                                                                    gap: '10px',
                                                                                    'margin-top': '15px !important',
                                                                                },
                                                                            },
                                                                        ],
                                                                        css: {
                                                                            display: 'flex',
                                                                            'flex-direction': 'column',
                                                                            'justify-content': 'center',
                                                                            'align-items': 'center',
                                                                            gap: '0px !important',
                                                                        },
                                                                    },
                                                                })
                                                                .show(); // Show registered user popup
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Close the popup
                                        $$('myForm222').clear(); // Clear the form
                                    }
                                },
                            },
                        ],
                        css: {
                            display: 'flex',
                            'justify-content': 'center',
                            'align-items': 'center',
                            'margin-top': '20px !important',
                        },
                    },
                ],
                css: {
                    display: 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'align-items': 'center',
                    gap: '10px',
                },
                rules: {
                    docnumber: webix.rules.isNotEmpty, // Validation rule for document number
                },
            },
        });

        // Left panel configuration
        const left = {
            id: 'BIA_client_2',
            responsiveCell: false,
            hidden: true,
            rows: [
                {
                    view: 'toolbar',
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Apuestas Deportivas'), // Label for sports betting
                            width: 300,
                        },
                        {},
                        {
                            hidden: !devConfig.getOnRelationshipUserOnline(), // Show if user is online
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-user',
                                    css: 'webix_primaryIconCustom',
                                },
                                {
                                    id: 'BIA_client_ID',
                                    view: 'text',
                                    width: 140,
                                    disabled: true,
                                    css: 'webix_primaryCustom',
                                    value: 'Cargando...', // Loading message
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    css: 'webix_primaryExitCustom',
                                    click: function () {
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Account/LogoutRelationshipUser', // API endpoint for logout
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        localStorage.removeItem(
                                                            'relationshipUserOnline', // Clear local storage on error
                                                        );
                                                        devConfig.setRelationshipUserOnline('');
                                                        $$('BIA_client').show(); // Show client view
                                                        $$('BIA_client_2').hide(); // Hide secondary client view
                                                        $$('BIA_client_ID').setValue(''); // Clear client ID
                                                        $$('BIA_client_ID').refresh(); // Refresh client ID
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        localStorage.removeItem(
                                                            'relationshipUserOnline', // Clear local storage on success
                                                        );
                                                        devConfig.setRelationshipUserOnline('');
                                                        $$('BIA_client').show(); // Show client view
                                                        $$('BIA_client_2').hide(); // Hide secondary client view
                                                        $$('BIA_client_ID').setValue(''); // Clear client ID
                                                        $$('BIA_client_ID').refresh(); // Refresh client ID
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    cols: [SportBets], // Include SportBets component
                },
            ],
        };

        webix.ui.fullScreen(); // Set Webix UI to full screen
        webix.Touch.limit(); // Limit touch events for mobile devices

        // Main layout configuration
        return {
            id: 'BIA_client_Main',
            type: 'wide',
            responsive: true,
            css: 'out',
            cols: [
                {
                    id: 'BIA_client',
                    responsiveCell: false,
                    rows: [
                        {
                            view: 'toolbar',
                            css: theme,
                            elements: [
                                {
                                    view: 'label',
                                    label: _('Apuestas Deportivas'), // Label for sports betting
                                    width: 300,
                                },
                            ],
                        },
                        {
                            view: 'template',
                            css: 'webix_template33',
                            template: `<div style='display: flex; justify-content: center; align-items: center; height: 100%; background-color: #A9A9A9'><button class='my-custom-button'>Iniciar sesión</button></div>`, // Template for login button
                            onClick: {
                                'my-custom-button': function () {
                                    $$('filterPopup11').show(); // Show login popup
                                },
                            },
                        },
                    ],
                },
                !devConfig.getOnRelationshipUserOnline()
                    ? left // Show left panel if user is not online
                    : devConfig.getRelationshipUserOnline() !== ''
                      ? left // Show left panel if user is online
                      : { hidden: true }, // Hide if no relationship
            ],
        };
    }

    /**
     * Initializes the view and checks user relationship status.
     */
    init() {
        const theme = this.app.config.theme; // Current theme configuration
        const relationshipUser = devConfig.getRelationshipUserOnline(); // Get online user relationship

        if (!devConfig.getOnRelationshipUserOnline()) {
            $$('BIA_client').hide(); // Hide client view if not online
            $$('BIA_client_2').show(); // Show secondary client view
            webix.message({
                type: "error",
                text: "Funcionalidad de apuestas anónimas no disponible para este contexto. Contacta al administrador.",
            });
        } else if (relationshipUser !== undefined && relationshipUser !== '') {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'Account/OnlineUserRelationship', // API endpoint for user relationship
                    {
                        docnumber: relationshipUser, // Send document number
                    },
                    {
                        error: function (text, data, XmlHttpRequest) {
                            localStorage.removeItem('relationshipUserOnline'); // Clear local storage on error
                            devConfig.setRelationshipUserOnline('');
                        },
                        success: function (text, data, XmlHttpRequest) {
                            let json = JSON.parse(text); // Parse response
                            $$('BIA_client_ID').setValue(json.data[0]); // Set client ID
                            $$('BIA_client_ID').refresh(); // Refresh client ID
                        },
                    },
                );
            $$('BIA_client').hide(); // Hide client view
            $$('BIA_client_2').show(); // Show secondary client view
        }
    }
}

// FILE DOCUMENTED
